// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.block-slider[data-v-c16b9aca]{overscroll-behavior-x:none;overflow:hidden}.block-slider-content[data-v-c16b9aca]{display:flex;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important;user-grab:none!important;transition:transform;will-change:transform}.block-slider-animate[data-v-c16b9aca]{transition:transform .2s ease-in}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
